import React, { useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faUserFriends,
  faCalendarAlt,
  faMusic,
} from "@fortawesome/free-solid-svg-icons";
import BookingModal from "./BookingModal";
import { Link } from "react-router-dom";

export const BookingContent = () => {
  const [date, setDate] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const bookedDates = [new Date("2024-04-22"), new Date("2024-04-27")]; // Updated booked dates

  const onChange = (date) => {
    setDate(date);
  };

  const Loader = () => (
    <div className="loader">
      <div className="spinner"></div>
    </div>
  );

  const tileClassName = ({ date }) => {
    const isBooked = bookedDates.some(
      (d) => d.toDateString() === date.toDateString()
    );
    return isBooked ? "booked-date" : "available-date";
  };

  const onClickDay = (value, event) => {
    const clickedDate = new Date(value);
    const isBooked = bookedDates.some(
      (d) => d.toDateString() === clickedDate.toDateString()
    );
    if (isBooked) {
      alert(
        `This date (${clickedDate.toDateString()}) has already been booked.`
      );
    }
  };

  const handleBooking = () => {
    setLoading(true);
    // Simulate booking process, replace setTimeout with your actual booking logic
    setTimeout(() => {
      setLoading(false);
      setIsModalOpen(true);
    }, 2000);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div id="BookingContent">
      <h1>Charter</h1>
      <div className="Textare">
        <ul>
          <li>
            <FontAwesomeIcon icon={faMapMarkerAlt} /> San Jacinto Monument{" "}
          </li>
          <li>
            <FontAwesomeIcon icon={faCalendarAlt} /> 11, June 2024
          </li>
        </ul>
        <ul>
          <li>
            <FontAwesomeIcon icon={faUserFriends} /> Guests{" "}
          </li>
          <li>
            <FontAwesomeIcon icon={faMusic} /> Speakers Available
          </li>
        </ul>
      </div>
      <div id="bookingPrice">
        <h2>From $20.00/Per Day</h2>
      </div>
      <div id="bookingCalendar">
        <p>Date</p>
        <div className="bookingbgcolor">
          <ul>
            <li>
              <span></span>Red Color Booked
            </li>
          </ul>
        </div>
        <Calendar
          onChange={onChange}
          value={date}
          tileClassName={tileClassName}
          onClickDay={onClickDay}
        />
        <div id="bookbtton">
          {loading ? (
            <Loader />
          ) : (
            <button onClick={handleBooking}>Book Now</button>
          )}
        </div>
      </div>
      <BookingModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
};
